import {SetValueConfig, UseFormReturn} from 'react-hook-form';

import {SaleVehicle, SaleVehiclePhoto} from '../../types/SaleVehicle';

export interface FormUpdatePhotosActionParams {
  form: UseFormReturn<SaleVehicle>;
  photos: SaleVehiclePhoto[];
}

const DEFAULT_OPTIONS = {
  shouldDirty: true,
  shouldValidate: false,
} satisfies SetValueConfig;

/**
 * XState action for updating the form photos array from external sources
 */
export const formUpdatePhotosAction = (
  _context: unknown,
  params: FormUpdatePhotosActionParams
): void => {
  const {form, photos} = params;
  form.setValue('photos', photos, DEFAULT_OPTIONS);
};
